import e from "../managers/braze-instance.js";
import na from "./push-manager-factory.js";
export function requestPushPermission(r, n) {
  if (e.X())
    return na.m().subscribe((n, o, t) => {
      const s = e.cr();
      s && s.requestImmediateDataFlush(), "function" == typeof r && r(n, o, t);
    }, n);
}
